import { render, staticRenderFns } from "./withdraw-details.vue?vue&type=template&id=b20e1046&scoped=true"
import script from "./withdraw-details.vue?vue&type=script&lang=js"
export * from "./withdraw-details.vue?vue&type=script&lang=js"
import style0 from "./withdraw-details.vue?vue&type=style&index=0&id=b20e1046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20e1046",
  null
  
)

export default component.exports